import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { DepartmentActions } from './department.actions';
import { DepartmentSelectors } from './department.selectors';

@Injectable({ providedIn: 'root' })
export class DepartmentStore {
  state$ = this.store.select(DepartmentSelectors.getState());

  constructor(private store: Store) {}

  readDepartments(): void {
    this.store.dispatch(DepartmentActions.getAllDepartments());
  }

  putDepartment(departmentName: string, installationId: string): void {
    this.store.dispatch(
      DepartmentActions.updateDepartment({
        departmentName,
        installationId,
      })
    );
  }

  deleteDepartment(installationId: string): void {
    this.store.dispatch(DepartmentActions.deleteDepartment({ installationId }));
  }
}
